import { FLAGSHIP_KEYS } from '@mafc/common'
import { onLog } from './flagShipWrapper'
const {
  DecisionMode,
  Flagship,
  FlagshipStatus
} = require('@flagship.io/react-sdk')
export const startFlagshipSDK = () => {
  if (
    Flagship.getStatus() &&
    Flagship.getStatus() !== FlagshipStatus.NOT_INITIALIZED
  ) {
    return
  }
  Flagship.start(FLAGSHIP_KEYS.envKey, FLAGSHIP_KEYS.apiKey, {
    fetchNow: false,
    decisionMode: DecisionMode.DECISION_API,
    onLog: onLog
  })
}
